import { render, staticRenderFns } from "./RolLabelType1.vue?vue&type=template&id=d32192b8&"
import script from "./RolLabelType1.vue?vue&type=script&lang=js&"
export * from "./RolLabelType1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports